import { Notification, Process } from '../interfaces';

/**
 * Base class from which cancelable events can derive. Provides preventDefault
 *   and isDefaultPrevented methods.
 */
class CancelableEvent {
	private defaultPrevented = false;

	public preventDefault(): void {
		this.defaultPrevented = true;
	}

	public isDefaultPrevented(): boolean {
		return this.defaultPrevented;
	}
}

/**
 * Called when a notification has been dismissed. If not cancelled, removes the
 *   notification.
 */
export class DismissEvent extends CancelableEvent {
	constructor(public notification: Notification) {
		super();
	}
}

/**
 * Called when all notifications have been dismissed. If not cancelled, removes
 *   all notifications.
 */
export class DismissAllEvent extends CancelableEvent {}

/**
 * Called when a notification has been clicked (not dismissed). If not
 *   cancelled, follows the notification's Data.Path (if applicable).
 */
export class NotificationClickEvent extends CancelableEvent {
	constructor(public notification: Notification, public elem: Element) {
		super();
	}
}

/**
 * Called when a process has received either a success or error message. If not
 *   cancelled, begins an auto-dismiss timer for the process.
 */
export class ProcessFinishEvent extends CancelableEvent {
	constructor(public process: Process, public elem: Element) {
		super();
	}
}

/**
 * Called when a process has been clicked. If not cancelled, dismisses the
 * process.
 */
export class ProcessClickEvent extends CancelableEvent {
	constructor(public process: Process, public elem: Element) {
		super();
	}
}
